import * as Yup from 'yup';

export const IntelligenceModelValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  path: Yup.string().required('Path is required'),
  host: Yup.string().required('Host is required'),
  version: Yup.string().required('Version is required')
});
